export default __webpack_public_path__ + "static/media/drag-handle.0cac4286.svg";